import paymentIcon from "../../../../../../assets/paymentIcon.png";
import closeIcon from "../../../../../../assets/closeIcon.png";
import TableAddNewpayments from "../../../../../../components/TableAddNewPayments";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../../../../services/api";
import TableEditPayment from "../../../../../../components/TableEditPayment";

const EditarPagamento = () => {
  const { id, orderId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState({});

  const handleNavigate = () => {
    navigate(`/pedidos/detalhes/${orderId}`);
  };

  useEffect(() => {
    const fetchPayment = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`/payments/${id}`);
        setPayment(response.data);
      } catch (error) {
        console.log("erro ao obter pagamento: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPayment();
  }, []);

  if (isLoading) return <h1>carregando...</h1>;

  return (
    <div className="bg-extraLightGray rounded-md p-5 relative flex-1 h-full flex-grow justify-between flex-col flex">
      <img
        src={closeIcon}
        alt="Ícone para fechar"
        className="w-[30px] h-[30px] absolute top-3 right-3 cursor-pointer"
        onClick={handleNavigate}
      />
      <div className="mx-8">
        <div className="flex items-center border-b border-lightGray pb-4">
          <img
            src={paymentIcon}
            alt="ícone de pagamento"
            className="w-[60px] h-[60px] ml-2"
          />
          <h2 className="ml-10 text-2xl font-semibold">Editar Pagamento</h2>
        </div>

        <TableEditPayment payment={payment} setPayment={setPayment} />
      </div>
    </div>
  );
};

export default EditarPagamento;
